export const generateId = () => {
  const cryptoObj =
    (typeof window !== "undefined" && window.crypto) || null;

  if (cryptoObj && typeof cryptoObj.randomUUID === "function") {
    return cryptoObj.randomUUID();
  }

  const ts = Date.now().toString(36);
  const rand = Math.random().toString(36).slice(2, 10);
  return `id-${ts}-${rand}`;
};
